<template>
  <button v-on:click='addPanel' class='button'>Add Panel</button>
</template>

<script>

export default {
  name: 'AddPanel',
  methods: {
    addPanel() {
      this.$store.dispatch('addPanel');
    },
  },
};
</script>

<style scoped>

</style>
